var map = {
	"./01-login.jpg": 678,
	"./02-login.jpg": 679,
	"./03-login.jpg": 680,
	"./04-login.jpg": 681,
	"./05-login.jpg": 682
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 677;


//////////////////
// WEBPACK FOOTER
// ./src/assets nonrecursive \.jpg$
// module id = 677
// module chunks = 0